import { registerBlockType } from '@wordpress/blocks';
import { Gallery } from './gallery.js';
import { Modal } from './modal.js';
import { setAccordions, isElementInViewport, createElement, collapseAfterNElements, extendLinkToItem} from './helpers.js';
import { Swiper } from 'swiper';
import { Navigation, Pagination, Autoplay, Scrollbar, EffectFade, EffectFlip, EffectCards } from 'swiper/modules';

if(typeof afgBlocks !== 'undefined') {
  if(afgBlocks.hasOwnProperty('blockKeys')) {
    if(afgBlocks.blockKeys.length !== 0) {
      afgBlocks.blockKeys.forEach((key) => {
       
        const config = require(`../views/blocks/${key}/block.json`);
        const registerKey = 'acf/' + key;
        registerBlockType(registerKey, config);
      });
    }
  }
}

if(typeof window.Swiper === 'undefined') window.Swiper = Swiper;
if(typeof window.Navigation === 'undefined') window.Navigation = Navigation;
if(typeof window.Pagination === 'undefined') window.Pagination = Pagination;
if(typeof window.Autoplay === 'undefined') window.Autoplay = Autoplay;
if(typeof window.Scrollbar === 'undefined') window.Scrollbar = Scrollbar;
if(typeof window.EffectFade === 'undefined') window.EffectFade = EffectFade;
if(typeof window.EffectFlip === 'undefined') window.EffectFlip = EffectFlip;
if(typeof window.EffectCards === 'undefined') window.EffectCards = EffectCards;
if(typeof window.Gallery === 'undefined') window.Gallery = Gallery;
if(typeof window.Modal === 'undefined') window.Modal = Modal;
if(typeof window.setAccordions === 'undefined') window.setAccordions = setAccordions;
if(typeof window.isElementInViewport === 'undefined') window.isElementInViewport = isElementInViewport;
if(typeof window.createElement === 'undefined') window.createElement = createElement;
if(typeof window.collapseAfterNElements === 'undefined') window.collapseAfterNElements = collapseAfterNElements;
if(typeof window.extendLinkToItem === 'undefined') window.extendLinkToItem = extendLinkToItem;